import React from 'react'
import PropTypes from 'prop-types'

const ImplementationIcon = ({ className, id }) => (
  <svg
    className={className}
    fill="none"
    height="75"
    id={id}
    viewBox="0 0 75 75"
    width="75"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="37.5" cy="37.5" fill="url(#paint0_linear_457_1743)" r="37.5" />
    <rect height="5" rx="2.5" stroke="white" width="44" x="15" y="21" />
    <rect
      fill="white"
      fillOpacity="0.4"
      height="5"
      rx="2.5"
      stroke="white"
      width="24"
      x="15"
      y="21"
    />
    <rect height="5" rx="2.5" stroke="white" width="44" x="15" y="35" />
    <rect
      fill="white"
      fillOpacity="0.4"
      height="5"
      rx="2.5"
      stroke="white"
      width="38"
      x="15"
      y="35"
    />
    <rect height="5" rx="2.5" stroke="white" width="44" x="15" y="49" />
    <rect
      fill="white"
      fillOpacity="0.4"
      height="5"
      rx="2.5"
      stroke="white"
      width="31"
      x="15"
      y="49"
    />
    <rect
      fill="white"
      height="7.90741"
      rx="1.45371"
      stroke="white"
      strokeWidth="1.09259"
      width="2.90741"
      x="36.5463"
      y="19.5463"
    />
    <rect
      fill="white"
      height="7.90741"
      rx="1.45371"
      stroke="white"
      strokeWidth="1.09259"
      width="2.90741"
      x="50.5463"
      y="33.5463"
    />
    <rect fill="white" height="9" rx="2" width="4" x="43" y="47" />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_457_1743"
        x1="51"
        x2="-2.42889e-07"
        y1="20"
        y2="107.5"
      >
        <stop stopColor="#04817C" />
        <stop offset="1" stopColor="#002855" />
      </linearGradient>
    </defs>
  </svg>
)

ImplementationIcon.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
}

export default ImplementationIcon
